module.exports = {
  printTeamSingle: `

  @page {
    size: A4;
  }
  * {
    box-sizing: border-box;
  }
  .titlename>img{
    width: 78px;
    height: 55px;
  }
.radioGroup {
  padding: .5em 0 .5em 1em;
  display: flex;
  flex-wrap: wrap;
  gap: 15px 10px;
}
.radio {
  display: flex;
  align-items: center;
  gap: 3px;
}
.radio span {
  display: inline-flex;
  width: 3em;
  border-bottom: 1px solid #5E5E5E;
  margin-inline: .5em;
  height: 1.5em;
}
.radio>div:nth-child(2) {
  display: flex;
  align-items: center;
}
.radio>div:nth-child(1) {
  width: 18px;
  height: 18px;
  border-radius: 10px;
  border: 1px solid #5E5E5E;
  display: flex;
  align-items: center;
  justify-content: center;
}
.radio>div:nth-child(1).checked::before {
  content: '✔';
}
.space {
  display: inline-flex;
  min-width: 6em;
}
.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.remark {
  flex: 1;
  border: 1px solid #5E5E5E;
  min-height: 180px;
  padding: .7em 1em;

}
.subtitle {
color: #5E5E5E;
font-family: Noto Sans TC;
font-size: 20px;
font-style: normal;
font-weight: 500;
line-height: normal;
letter-spacing: 1.5px;

}
.table2 tr:nth-child(1)>td:nth-child(1),
.table2 tr:nth-child(1)>td:nth-child(2) {
  background: #DADADA;
  color: #5E5E5E;
  font-family: Noto Sans TC;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 1.5px;
}
.table2 td:nth-child(1), .table2 td:nth-child(2) {
  width: 150px;
  text-align: center;
}
.table2 tr:nth-child(1) > td:nth-child(3) {
  text-align: center;
}
.table2 tr:nth-child(odd) td:last-child {
  text-align: start;
}
.table2 td {
  height: 45px;
}
.table2 tr:not(:last-child) td {
  border-bottom: 1px solid #5E5E5E;
}
.table2 td:not(:last-child), .table2 td:nth-child(2):last-child {
  border-right: 1px solid #5E5E5E;
}
.table2 {
  text-align: start;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.table1 {
  text-align: start;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.table1 table, .table2 table {
  border: 1px solid #5E5E5E;
  width: 100%;
  border-collapse: collapse;
}
.table1 tr:not(:last-child) td {
  border-bottom: 1px solid #5E5E5E;
}
.table1 td:not(:last-child) {
  border-right: 1px solid #5E5E5E;
}
.table1 td:nth-child(odd) {
  width: 150px;
  text-align: center;
  height: 45px;
}
.table1 td:nth-child(even) {
  padding-left: 13px;
  text-align: start;
  height: 35px;
  width: calc(50% - 150px);
}
.table1 td {
  color: #5E5E5E;
  font-family: Noto Sans TC;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 1.2px;
}
#preview {
  display: flex;
  flex-direction: column;
  gap: 21px;
  background-color: #FFFFFF;
  z-index: 100;
}
.titlename {
  color: #5E5E5E;
  font-family: Noto Sans TC;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 4px;
  display: flex;
  align-items: center;
  flex-direction: column;
}`
}
